/**
 * The storefront extensions module for the combined estate: every vertical's themes and
 * blocks in one build.
 *
 * `STOREFRONT_EXTENSIONS_MODULE` names ONE file (commerce/frontends/storefront/next.config.ts,
 * "Build-time extensions"), so running solar and spatial on one server means one module that
 * concatenates both lists rather than two builds. Each vertical's own module stays exactly as
 * it is, and keeps working on its own when the estate is split again.
 *
 * The imports are relative on purpose. This file is not a workspace package — it belongs to no
 * pnpm workspace and has no package.json — so there is no package name to import by. Inside
 * the image the repository is at /repo with the same layout, which is why these paths hold
 * there as well as here. Each vertical's own imports (`@solar/theme-pv`,
 * `@spatial/theme-kitchen`) resolve from the node_modules of the package the file lives in,
 * so both workspaces must be installed in the image; Dockerfile.storefront installs all three.
 *
 * Nothing collides: the two verticals register different theme ids (`solar-pv`,
 * `spatial-kitchen`) and differently prefixed block views (`Solar*`, `SpatialKitchen*`), and a
 * shop renders the one theme its own site names.
 */
import solarExtensions from '../../../solar/frontends/storefront-extension/src/index';
import spatialExtensions from '../../../spatial/frontends/storefront-extension/src/index';

export const extensions = [...solarExtensions, ...spatialExtensions];

export default extensions;
